import type { TOC } from '@ember/component/template-only';

import visibleCheckContainer from 'webapp/modifiers/visible-check-container';
import AccountLogsTableRowComponent from 'webapp/components/account/logs/table-row';

import ActivityLog from 'webapp/models-custom/activity-log';
import FilterSortActivityLog from 'webapp/models-custom/filter-sort/activity-log';

interface AccountLogsTableComponentInterface {
	Element: HTMLDivElement;
	Args: {
		model: ActivityLog[];
		filterSort?: FilterSortActivityLog;
		showActions?: boolean;
		showAccount?: boolean;
		extraClass?: string;
		openEmailDetailsDialog?: (uniqueReferenceId: string | null) => void;
	};
}

const AccountLogsTableComponent: TOC<AccountLogsTableComponentInterface> = <template>
	<table
		id="activity-log-list"
		class="flexible-table bigtable has-avatar
			{{if @filterSort.noResults 'hide'}}
			{{@extraClass}}"
		{{visibleCheckContainer}}
	>
		<colgroup>
			<col class="c1" />
			{{#if @showAccount}}
				<col class="c-account" />
			{{/if}}
			<col />
			<col class="c3" />
			{{#if @showActions}}
				<col class="c4" />
			{{/if}}
		</colgroup>
		<thead>
			<tr>
				<th>Timestamp</th>
				{{#if @showAccount}}
					<th>Account</th>
				{{/if}}
				<th>Activity</th>
				<th>User</th>
				{{#if @showActions}}
					<th></th>
				{{/if}}
			</tr>
		</thead>
		<tbody>

			{{#each @model as |activityLog|}}
				<AccountLogsTableRowComponent
					@model={{activityLog}}
					@showAction={{@showActions}}
					@showAccount={{@showAccount}}
					@openEmailDetailsDialog={{@openEmailDetailsDialog}}
				/>
			{{/each}}

		</tbody>
	</table>
</template>;

export default AccountLogsTableComponent;
